import React from "react";
import { Modal, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { cancelWithdrawalRequestAction } from "../../Action/user.action";

const CancelWithdrawalRequest = ({
    showCancelRequestModal,
    handleClose,
    data
}) => {

    const handleYesClick = async () => {
        try {
            const res = await cancelWithdrawalRequestAction(data);
            if (res?.success) {
                toast.success(res?.message || "Request cancelled successfully");
                handleClose();
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } else {
                toast.error(res?.message || "Failed to cancel request");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <Modal
            show={showCancelRequestModal}
            onHide={handleClose}
            centered
            contentClassName="border-0 p-0 rounded-4 shadow-lg overflow-hidden"
        >
            <div
                style={{
                    background:
                        "linear-gradient(133deg, #41d3ffa5 0%, #7e42ffa0 47.4%, #dc3fffaf 96.19%)",
                    color: "#fff",
                    padding: "1.5rem",
                    textAlign: "center"
                }}
            >
                <h4 className="fw-bold mb-0">Cancel Withdrawal Request?</h4>
            </div>

            <Modal.Body className="text-center text-dark p-4">
                <p className="fs-6 mb-4">
                    Are you sure you want to cancel this withdrawal request?
                </p>

                <div className="d-flex justify-content-center gap-3">


                    {/* YES BUTTON */}
                    <Button
                        className="py-2 px-4 fw-semibold text-white border-0"
                        style={{
                            borderRadius: "10px",
                            background:
                                "linear-gradient(133deg, #41d3ffa5 0%, #7e42ffa0 47.4%, #dc3fffaf 96.19%)",
                            transition: "transform 0.2s ease"
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.05)")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                        }
                        onClick={handleYesClick}
                    >
                        Yes
                    </Button>

                    {/* NO BUTTON */}
                    <Button
                        variant="secondary"
                        className="py-2 px-4 fw-semibold border-0"
                        style={{
                            borderRadius: "10px",
                            background: "#6c757d"
                        }}
                        onClick={handleClose}
                    >
                        No
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default CancelWithdrawalRequest;
